import { createStyles } from '@mantine/core';
import {
	ENTITY_NODE_GAP,
	ENTITY_NODE_PADDING,
} from '../EntityNode/EntityNode.constants';
import type { EntityNodeChildProps } from './EntityNodeChild.types';
import { ENTITY_CHILDREN_ROW_HEIGHT } from './EntityNodeChildren.constants';

export const useStyles = createStyles(
	(
		theme,
		{
			highlighted,
			focused,
			order,
			createAccess,
			disabled,
		}: Pick<EntityNodeChildProps, 'highlighted' | 'focused' | 'order'> & {
			createAccess?: boolean;
			disabled?: boolean;
		}
	) => {
		const cursor = disabled ? 'default' : 'pointer';

		let hoverBackgroundColor = disabled
			? theme.other.getColor('surface/primary/default')
			: theme.other.getColor('surface/primary/hover');

		let activeBackgroundColor = disabled
			? theme.other.getColor('surface/primary/default')
			: theme.other.getColor('surface/primary/active');

		if (highlighted) {
			hoverBackgroundColor = theme.other.getColor('surface/emphasis/default');
			activeBackgroundColor = theme.other.getColor('surface/emphasis/default');
		}

		return {
			wrapper: {
				cursor,
				justifyContent: 'space-between',
				minHeight: ENTITY_CHILDREN_ROW_HEIGHT,
				paddingLeft: theme.spacing.sm,
				paddingRight: theme.spacing.sm,
				borderRadius: theme.radius.sm,
				gap: theme.spacing.xs,
				backgroundColor: highlighted
					? theme.other.getColor('surface/emphasis/default')
					: theme.other.getColor('surface/primary/default'),
				borderColor: focused ? '#005BD3' : 'unset',
				borderStyle: focused ? 'solid' : 'unset',
				borderWidth: focused ? 2 : 'unset',
				'&:hover': {
					backgroundColor: hoverBackgroundColor,
				},
				'&:active': {
					backgroundColor: activeBackgroundColor,
				},
			},
			handle: {
				visibility: 'hidden',
				top: `${
					2 * ENTITY_NODE_GAP +
					ENTITY_NODE_PADDING +
					2 * ENTITY_CHILDREN_ROW_HEIGHT +
					ENTITY_CHILDREN_ROW_HEIGHT * order +
					ENTITY_CHILDREN_ROW_HEIGHT * 0.5
				}px !important`,
			},
			handleLeft: {
				left: createAccess
					? `-${theme.other.space[4]}px !important`
					: `0px !important`,
			},
			handleRight: {
				right: createAccess
					? `-${theme.other.space[4]}px !important`
					: `0px !important`,
			},
			lineageIndicatorIcon: {
				stroke: theme.other.getColor('icon/secondary/default'),
				'&:hover': {
					stroke: theme.other.getColor('icon/secondary/hover'),
				},
				'&:active': {
					stroke: theme.other.getColor('icon/secondary/active'),
				},
			},
		};
	}
);
